import baseAPI from '@/http'

const router = 'api/municipio/municipiogruposolucao'

export const cityGroupSolutionAPI = {
  create: (cityGroupSolution) => baseAPI.post(router, cityGroupSolution),
  update: (cityGroupSolution) => baseAPI.put(router, cityGroupSolution),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByCity: (id) => baseAPI.get(`${router}/list-by-municipio/${id}`),
  getByProject: (id) => baseAPI.get(`${router}/get-by-projeto/${id}`),
  groupSolutionStarted: (groupSolution) => baseAPI.post(`${router + '/grupo-solucao-iniciado'}`, groupSolution)
}
